import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {CompetitionsSliderWidgetFetchHandler} from "./competitions-slider-widget.fetch-handler";
import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {CompetitionsSliderWidgetCompetitionChangeHandler} from "./competitions-slider-widget.competition-change-handler";
import {CompetitionsSliderWidgetPopulateDataHandler} from "./competitions-slider-widget.populate-data-handler";
import {CompetitionsSliderMenuClickEventHandler} from "./competitions-slider-menu.click-event.handler";
import {CompetitionsSliderEntityClickEventHandler} from "./competitions-slider-entity.click-event.handler";
import {CompetitionsSliderEntityDisplayEventHandler} from "./competitions-slider-entity.display-event.handler";
import {CompetitionsSliderWidgetPartialGamesFetchHandler} from "./competitions-slider-widget.partial-games.fetch-handler";
import {SliderSlideClickEventHandler} from "../../../core/handlers/slider.slide-click-event.handler";
import {MatchDetailsClickEventHandler} from "../../../core/handlers/match-details.click-event.handler";
import {AllScoresLinkClickEventHandler} from "../../../core/handlers/all-scores-link.click-event.handler";
import {CompetitionsSliderWidgetPopulateCompetitionsDataHandler} from "./competitions-slider-widget.populate-competitions.data-handler";
import {WidgetLoadedEventHandler} from "../../../core/handlers/widget-loaded-event.handler";
import {PopulateSponsorshipBookmakerHandler} from "../../../core/handlers/populate-sponsorship-bookmaker.handler";
import {CompetitionsSliderWidgetDisplayEventHandler} from "./competitions-slider-widget.display-event.handler";

export class CompetitionsSliderWidgetHandlers extends HandlerList {

  static injectables = [
    CompetitionsSliderWidgetPopulateDataHandler,
    CompetitionsSliderWidgetFetchHandler,
    CompetitionsSliderWidgetCompetitionChangeHandler,
    CompetitionsSliderMenuClickEventHandler,
    CompetitionsSliderEntityClickEventHandler,
    CompetitionsSliderEntityDisplayEventHandler,
    CompetitionsSliderWidgetPartialGamesFetchHandler,
    CompetitionsSliderWidgetPopulateCompetitionsDataHandler,
    CompetitionsSliderWidgetDisplayEventHandler,
    TimingHandler,
    SliderSlideClickEventHandler,
    MatchDetailsClickEventHandler,
    AllScoresLinkClickEventHandler,
    WidgetLoadedEventHandler,
    PopulateSponsorshipBookmakerHandler
  ];

  constructor(
    competitionsSliderWidgetPopulateDataHandler: CompetitionsSliderWidgetPopulateDataHandler,
    competitionsSliderWidgetFetchHandler: CompetitionsSliderWidgetFetchHandler,
    competitionsSliderWidgetChangeHandler: CompetitionsSliderWidgetCompetitionChangeHandler,
    competitionsSliderMenuClickEventHandler: CompetitionsSliderMenuClickEventHandler,
    competitionsSliderEntityClickEventHandler: CompetitionsSliderEntityClickEventHandler,
    competitionsSliderEntityDisplayEventHandler: CompetitionsSliderEntityDisplayEventHandler,
    competitionsSliderWidgetPartialGamesFetchHandler: CompetitionsSliderWidgetPartialGamesFetchHandler,
    competitionsSliderWidgetPopulateCompetitionsDataHandler: CompetitionsSliderWidgetPopulateCompetitionsDataHandler,
    competitionsSliderWidgetDisplayEventHandler: CompetitionsSliderWidgetDisplayEventHandler,
    timingHandler: TimingHandler,
    sliderSlideClickEventHandler: SliderSlideClickEventHandler,
    matchDetailsClickEventHandler: MatchDetailsClickEventHandler,
    allScoresLinkClickEventHandler: AllScoresLinkClickEventHandler,
    widgetLoadedEventHandler: WidgetLoadedEventHandler,
    populateSponsorshipBookmakerHandler: PopulateSponsorshipBookmakerHandler,
  ) {
    super();
    [
      competitionsSliderWidgetPopulateDataHandler,
      competitionsSliderWidgetFetchHandler,
      competitionsSliderWidgetChangeHandler,
      competitionsSliderMenuClickEventHandler,
      competitionsSliderEntityClickEventHandler,
      competitionsSliderEntityDisplayEventHandler,
      competitionsSliderWidgetPartialGamesFetchHandler,
      competitionsSliderWidgetPopulateCompetitionsDataHandler,
      competitionsSliderWidgetDisplayEventHandler,
      timingHandler,
      sliderSlideClickEventHandler,
      matchDetailsClickEventHandler,
      allScoresLinkClickEventHandler,
      widgetLoadedEventHandler,
      populateSponsorshipBookmakerHandler
    ].forEach(handler => this.add(handler));
  }
}
